import $ from 'jquery';

const mainSlider = () => {
    console.log("Main Slider");
};

export default mainSlider;
